import React, { useContext, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import IconFieldComponent from "../../components/fields/IconFieldComponent";
import LogoComponent from "../../components/LogoComponent";
import { toast } from 'react-toastify';
import { forgotPassword } from "../../APIs/UserRequests";

export default function ForgotPasswordPage() {

    const { t } = useContext(TranslatorContext);
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [emailError, setEmailError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Reset errors
        setEmailError('');
        
        // Validation
        if (!email) {
            setEmailError(t('email_is_required'));
            return;
        }
        
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setEmailError(t('please_enter_valid_email'));
            return;
        }

        setLoading(true);
        
        try {
            const response = await forgotPassword(email);
            toast.success(response.data.message || t('reset_link_sent_successfully'));
            setEmail(''); // Clear the form
        } catch (error) {
            const errorMessage = error.response?.data?.message || t('something_went_wrong');
            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mc-auth">
            <img 
                className="mc-auth-pattern" 
                src="images/pattern.webp"
                alt="pattern"
            />
            <div className="mc-auth-group">
                <LogoComponent 
                    src="images/logo.webp"
                    alt="logo" 
                    href="/"
                    className="mc-auth-logo"
                />
                <h4 className="mc-auth-title">{t('reset_the_password')}</h4>
                <form className="mc-auth-form" onSubmit={handleSubmit}>
                    <IconFieldComponent 
                        icon="email"
                        type="email"
                        classes="h-sm"
                        placeholder={t('enter_your_email')}
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value);
                            setEmailError('');
                        }}
                    />
                    {emailError && <span className="mc-label-field" style={{ color: 'red', marginTop: '5px' }}>{emailError}</span>}
                    <ButtonComponent 
                        className="mc-auth-btn h-sm" 
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? t('sending...') : t('get_link')}
                    </ButtonComponent>
                </form>
                <div className="mc-auth-navigate">
                    <span>{t('remember_the_password')}?</span>
                    <AnchorComponent to="/login">{t('login')}</AnchorComponent>
                </div>
            </div>
        </div>
    );
}